import React from 'react';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import {useRecommendedParticipants} from '../../../../../../data/hooks/participant/useRecommendedParticipants';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';
import {HASHTRIGGER_OPEN_SUGGESTED_PARTICIPANTS} from '../../../../EventParticipants/EventParticipantsHeader/ParticipantsTabs/SuggestedParticipants/SuggestedParticipants';

function StepRecommendedParticipants(props) {
    const {eventId} = props,
        recommendedParticipants = useRecommendedParticipants(eventId),
        i18n = useI18n();

    return (
        <StartNetworkingStep href={`/events/${eventId}/participants#${HASHTRIGGER_OPEN_SUGGESTED_PARTICIPANTS}`} visible={!!recommendedParticipants.length}>
            {i18n['start.suggested_contacts']}
        </StartNetworkingStep>
    );
}

export default StepRecommendedParticipants;
